var generateStyle = function generateStyle(componentTheme) {
  return {
    answerMediaIcon: {
      marginRight: componentTheme.answerMediaIconMargin
    },
    embeddedImage: {
      '>img': {
        maxHeight: '400px',
        maxWidth: '400px',
        margin: componentTheme.embeddedImageMargin,
        paddingRight: componentTheme.embeddedImagePadding
      }
    },
    mediaToggle: {
      margin: componentTheme.mediaToggleMargin,
      textAlign: 'left',
      borderBottom: "1px solid ".concat(componentTheme.mediaToggleColor),
      borderLeft: "1px solid ".concat(componentTheme.mediaToggleColor),
      borderRight: "1px solid ".concat(componentTheme.mediaToggleColor),
      borderRadius: '5px'
    }
  };
};
export default generateStyle;